import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Swiper from "swiper"
import { Pagination, Navigation, EffectCards } from "swiper/modules"

gsap.registerPlugin(ScrollTrigger)

const pageId = document.querySelector("body").id
const isHomePage = ["home", "es", "fr", "ca"].includes(pageId)

if (isHomePage) {
  new Swiper(".galleries .swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    modules: [Pagination, Navigation],
    pagination: {
      el: ".swiper-dots",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      1025: {
        slidesPerView: 3,
      },
    },
  })

  document.querySelectorAll(".events .events__swiper").forEach((swiperEl) => {
    new Swiper(swiperEl.querySelector(".swiper"), {
      slidesPerView: 1.1,
      spaceBetween: 50,
      modules: [Pagination, Navigation],
      pagination: {
        el: swiperEl.querySelector(".swiper-dots"),
        clickable: true,
      },
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-next"),
        prevEl: swiperEl.querySelector(".swiper-prev"),
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
        },
      },
    })
  })

  new Swiper(".testimonials .swiper", {
    effect: 'cards',
    grabCursor: true,
    cardsEffect: {
      perSlideOffset: 8,
      perSlideRotate: 0,
      rotate: false,
      slideShadows: true,
    },
    modules: [Pagination, Navigation, EffectCards],
    pagination: {
      el: ".swiper-dots",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  })
}